import { render, staticRenderFns } from "./orderChartered.vue?vue&type=template&id=2f46d446"
import script from "./orderChartered.vue?vue&type=script&lang=js"
export * from "./orderChartered.vue?vue&type=script&lang=js"
import style0 from "./orderChartered.vue?vue&type=style&index=0&id=2f46d446&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports